import { Component, OnInit, HostListener } from '@angular/core';
import { CWSMSAPIService } from '../cwsmsapi.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MatMenuTrigger, MatIconRegistry } from '@angular/material';
import { BuyCreditsComponent } from '../buy-credits/buy-credits.component';

@Component({
  selector: 'app-billing-info',
  templateUrl: './billing-info.component.html',
  styleUrls: ['./billing-info.component.css']
})
export class BillingInfoComponent implements OnInit {

	errorMessage: string = "";
	messageCredits: number = 0;
	sidemenuOpen: boolean = true;
	screenHeight: number;
	screenWidth: number;
	billingInfo: any = {};
	loading: boolean = false;
	changesSaved: boolean = false;
	newUser: boolean = true;
	requiredFields: any = [
		"country",
		"companyName",
		"address",
		"zip",
		"city"
	];

	constructor(public cwsms: CWSMSAPIService, public router: Router, private route: ActivatedRoute) {
		this.onResize();
	}

	ngOnInit() {
	}

	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
		console.log(this.screenWidth+"x"+this.screenHeight);

		if (this.screenWidth < 720) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}
	}

	toggleSidemenu() {
		if (this.sidemenuOpen) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}
	}

	receivedSideMenuEvent(event) {
		if ("userData" in event) {
			this.messageCredits = parseFloat(event.userData.credits.N);

			if ("billingInfo" in event.userData) {
				this.newUser = false;
				var bi = event.userData.billingInfo.M;
				for (var key in bi) {
					this.billingInfo[key] = bi[key].S;
				}
			}
		}
	}

	shouldAddVAT() {
		return "country" in this.billingInfo && this.billingInfo.country.toLowerCase().startsWith("norway");
	}

	onChangedCountry(country) {
		this.billingInfo.country = country;
	}

	saveChanges() {
		this.changesSaved = false;
		console.log(this.billingInfo);

		var approved = true;
		for (var field of this.requiredFields) {
			if (!(field in this.billingInfo) || this.billingInfo[field].length <= 0) {
				approved = false;
				break;
			}
		}

		if (!approved) {
			this.errorMessage = "You need to fill in all the required fields before saving the changes.";
		} else {
			this.errorMessage = "";

			this.loading = true;
			this.cwsms.post('/user/billing-info', {billingInfo: this.billingInfo}, (err, data) => {
				this.loading = false;
				if (err) {
					this.errorMessage = err.message;
				} else {
					this.changesSaved = true;
					if (this.newUser) {
						this.router.navigate(['home']);
					}
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/billing-info/billing-info.component.ts